import moment from 'moment';

export const calcAccumulationThreshold = (insectGroup, date) => {
  const dt = moment(date);
  return insectGroup.short_name === 'CM' && dt.month() < 6
    ? insectGroup.accumulation_threshold / 2
    : insectGroup.accumulation_threshold;
};

export const trappingZoneResultsCounts = (
  selectedInsectGroup,
  trappingZoneResults,
  trappingZone
) => {
  // Count the number of sprays
  const sprays = trappingZoneResults.results.reduce(
    (accumulator, currentValue) =>
      accumulator + currentValue.trapping_zone_sprays.length,
    0
  );

  // Initialize counts
  let amountThresholdsMet = 0;
  let accumulationThresholdsMet = 0;
  let averageThresholdsMet = 0;
  let coveredThresholds = 0;
  let thresholdMetRecords = 0;
  let coveredThresholdRecords = 0;

  // Loop over each record
  trappingZoneResults.results.map((result) => {
    const dt = moment(result.date);
    const amounts = [];

    let thresholdMet = false;
    let coveredThreshold = false;

    // Loop over traps that trap this insect group
    trappingZone.traps
      .filter((trap) =>
        trap.trap_lure.insects.some(
          (insect) => insect.insect_group.id === selectedInsectGroup.id
        )
      )
      .forEach((trap) => {
        const trapResult = result.traps[trap.id];

        if (trapResult && result.trap_monitoring_records.length > 0) {
          if (
            trapResult.amount >= selectedInsectGroup.per_trap_catch_threshold
          ) {
            if (result.sprayed) {
              coveredThresholds++;
              coveredThreshold = true;
            } else {
              amountThresholdsMet++;
              thresholdMet = true;
            }
          }

          if (
            trapResult.accumulation >=
            calcAccumulationThreshold(selectedInsectGroup, dt)
          ) {
            if (result.sprayed) {
              coveredThresholds++;
              coveredThreshold = true;
            } else {
              accumulationThresholdsMet++;
              thresholdMet = true;
            }
          }
        }

        amounts.push(trapResult ? trapResult.amount : null);
      });

    // Check for an average threshold
    if (amounts.length > 0 && selectedInsectGroup.average_threshold !== null) {
      if (
        amounts.reduce(
          (accumulator, currentValue) => accumulator + currentValue
        ) /
          amounts.length >=
        selectedInsectGroup.average_threshold
      ) {
        if (result.sprayed) {
          coveredThresholds++;
          coveredThreshold = true;
        } else {
          averageThresholdsMet++;
          thresholdMet = true;
        }
      }
    }

    // Aggregated record counts
    if (coveredThreshold) coveredThresholdRecords++;
    else if (thresholdMet) thresholdMetRecords++;
  });

  return {
    sprays: sprays,
    amountThresholdsMet: amountThresholdsMet,
    accumulationThresholdsMet: accumulationThresholdsMet,
    averageThresholdsMet: averageThresholdsMet,
    coveredThresholds: coveredThresholds,
    coveredThresholdRecords: coveredThresholdRecords,
    thresholdMetRecords: thresholdMetRecords
  };
};

const downloadFile = (data) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'Trap-Export.csv');
  document.body.appendChild(link);
  link.click();
};

export const fetchTrapCSV = async (
  bearerToken,
  selectedDatabase,
  insectType,
  property,
  productionArea
) => {
  const url = new URL(process.env.REACT_APP_TRAPLOG_API_URL + 'api/export');
  url.searchParams.append('insect_type', insectType);
  url.searchParams.append('property_ids[]', property);
  if (productionArea) {
    url.searchParams.append('production_area', productionArea);
  }

  const response = await fetch(url.href, {
    method: 'GET',
    headers: {
      'Content-Type': 'text/csv',
      Accept: 'application/json',
      Authorization: 'Bearer ' + bearerToken,
      SeasonalDatabase: selectedDatabase
    }
  });
  // Request successful so download file.
  if (response.ok) {
    const data = await response.text();
    downloadFile(data);
    return true;
  } else {
    return false;
  }
};
